import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/UserGroup.svg'

export const IconUserGroup = IconSVG as IconComponent
